<script>
import './stylesheets/components/VsAlert';

export default {
  props: {
    message: String,
    type: String,
    error: [String, Boolean],
    noGutter: [String, Boolean],
  },
  computed: {
    classes() {
      return {
        'alert--table': this.type === 'table',
        'alert--cart': this.type === 'cart',
        'alert--error': this.error,
        'alert--no-gutter': this.noGutter,
      };
    },
  },
};
</script>

<template lang='pug'>
.alert(:class='classes')
  .alert__message(v-if='message', v-html='message')
  .alert__message(v-else)
    slot
</template>